import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import { getVoteNum, vote } from '@Container/common/client/services/api';
import errorBoundary from '@ifeng/errorBoundary';

class Vote extends React.PureComponent {
    static propTypes = {
        voteId: PropTypes.string,
        keywords: PropTypes.string,
        content: PropTypes.object,
    };

    state = {
        isVoted: false,
        voteNum: 0,
    };

    async componentDidMount() {
        try {
            const { voteId } = this.props;

            const data = await getVoteNum(`${voteId}ding`);

            this.setState({ voteNum: data.browse[`${voteId}ding`] });
        } catch (e) {
            console.error(e);
        }
    }

    vote = async () => {
        try {
            const { isVoted } = this.state;

            if (isVoted) {
                return;
            }

            const { voteId } = this.props;

            const data = await vote(`${voteId}ding`);

            this.setState({
                isVoted: !isVoted,
                voteNum: data,
            });
        } catch (e) {
            console.error(e);
        }
    };

    render() {
        const { isVoted, voteNum } = this.state;
        const { keywords, content } = this.props;
        const { isCloseLike, isOpenCandle, isOpenpray } = content;

        console.log(isCloseLike, isOpenCandle, isOpenpray, !isCloseLike && !isOpenCandle && !isOpenpray, '3333333');

        return (
            <>
                {!isCloseLike &&
                    !isOpenCandle &&
                    !isOpenpray && (
                        <div className={isVoted ? styles.voted : styles.vote} onClick={this.vote}>
                            推荐<span>{voteNum}</span>
                        </div>
                    )}
                {isCloseLike &&
                    isOpenCandle && (
                        <div className={isVoted ? styles.voted1 : styles.vote1} onClick={this.vote}>
                            蜡烛<span>{voteNum}</span>
                        </div>
                    )}
                {isCloseLike &&
                    isOpenpray && (
                        <div className={isVoted ? styles.voted2 : styles.vote2} onClick={this.vote}>
                            祈祷<span>{voteNum}</span>
                        </div>
                    )}
            </>
        );
    }
}

export default errorBoundary(Vote);
